import JobShadowView from '../Views/JobShadowView.vue'
import StartProject from "../Pages/StartProject.vue"
import DeepCustomerEmpathy2 from "../Pages/DeepCustomerEmpathy2"
import DeepCustomerEmpathy3 from "../Pages/DeepCustomerEmpathy3"
import DeepCustomerEmpathy4 from "../Pages/DeepCustomerEmpathy4"
import DeepCustomerEmpathy5 from "../Pages/DeepCustomerEmpathy5"
import DeepCustomerEmpathy6 from "../Pages/DeepCustomerEmpathy6"
import DeepCustomerEmpathy7 from "../Pages/DeepCustomerEmpathy7"
import GoBroadToGoNarrow8 from "../Pages/GoBroadToGoNarrow8";
import GoBroadToGoNarrow9 from "../Pages/GoBroadToGoNarrow9";
import GoBroadToGoNarrow10 from "../Pages/GoBroadToGoNarrow10";
import GoBroadToGoNarrow11 from "../Pages/GoBroadToGoNarrow11";
import GoBroadToGoNarrow12 from "../Pages/GoBroadToGoNarrow12";
import GoBroadToGoNarrow13 from "../Pages/GoBroadToGoNarrow13";
import GoBroadToGoNarrow13Other from "../Pages/GoBroadToGoNarrow13Other";
import RapidExperimentsWithCustomers14 from "../Pages/RapidExperimentsWithCustomers14";
import RapidExperimentsWithCustomers15 from "../Pages/RapidExperimentsWithCustomers15";
import RapidExperimentsWithCustomers16 from "../Pages/RapidExperimentsWithCustomers16";
import RapidExperimentsWithCustomers17 from "../Pages/RapidExperimentsWithCustomers17";
import RapidExperimentsWithCustomers18 from "../Pages/RapidExperimentsWithCustomers18";
import RapidExperimentsWithCustomers19 from "../Pages/RapidExperimentsWithCustomers19";
import RapidExperimentsWithCustomers20 from "../Pages/RapidExperimentsWithCustomers20";
import RapidExperimentsWithCustomers21 from "../Pages/RapidExperimentsWithCustomers21";
import RapidExperimentsWithCustomers22 from "../Pages/RapidExperimentsWithCustomers22";
import Finish23 from  "../Pages/Finish23";
import TimeToReset from "../Pages/TimeToReset"
import JSBeforeYouContinue from "../Pages/JSBeforeYouContinue";




const routes = [
    {
        path: '/job_shadow',
        component: JobShadowView,
        children: [
            {
                path: '/js_start_project',
                name: 'js_start_project',
                component: StartProject,
                meta: { authRequired: true, showNavigation: false, showNavigationInfo: false ,  hideSideNavigation: true },
                props: { newProject: true }
            },
            {
                path: '/js_before_you_continue/:index',
                name: 'js_before_you_continue',
                component: JSBeforeYouContinue,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true}
            },
            {
                path: '/js_edit_project/:index',
                name: 'js_edit_project',
                component: StartProject,
                meta: { authRequired: true, showNavigation: false, showNavigationInfo: false ,  hideSideNavigation: true },
                props: { newProject: false }
            },
            {
                path: '/js_deep_customer_empathy_2/:index',
                name: 'js_deep_customer_empathy_2',
                component: DeepCustomerEmpathy2,
                meta: { authRequired: true, showNavigation: false, showNavigationInfo: false , pageNumber: "2 of 22"}
            },
            {
                path: '/js_deep_customer_empathy_3/:index',
                name: 'js_deep_customer_empathy_3',
                component: DeepCustomerEmpathy3,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Deep Self Empathy", pageNumber: "3 of 22" }
            } ,
            {
                path: '/js_deep_customer_empathy_4/:index',
                name: 'js_deep_customer_empathy_4',
                component: DeepCustomerEmpathy4,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Deep Self Empathy", pageNumber: "4 of 22" }
            } ,
            {
                path: '/js_deep_customer_empathy_5/:index',
                name: 'js_deep_customer_empathy_5',
                component: DeepCustomerEmpathy5,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Deep Self Empathy", pageNumber: "5 of 22" }
            } ,
            {
                path: '/js_deep_customer_empathy_6/:index',
                name: 'js_deep_customer_empathy_6',
                component: DeepCustomerEmpathy6,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Deep Self Empathy", pageNumber: "6 of 22" }
            },
            {
                path: '/js_deep_customer_empathy_7/:index',
                name: 'js_deep_customer_empathy_7',
                component: DeepCustomerEmpathy7,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Deep Self Empathy", pageNumber: "7 of 22" }
            },
            {
                path: '/js_go_broad_to_go_narrow_8/:index',
                name: 'js_go_broad_to_go_narrow_8',
                component: GoBroadToGoNarrow8,
                meta: { authRequired: true, showNavigation: false, showNavigationInfo: false,  pageNumber: "8 of 22" }
            },
            {
                path: '/js_go_broad_to_go_narrow_9/:index',
                name: 'js_go_broad_to_go_narrow_9',
                component: GoBroadToGoNarrow9,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Go Broad To Go Narrow", pageNumber: "9 of 22"  }
            },
            {
                path: '/js_go_broad_to_go_narrow_10/:index',
                name: 'js_go_broad_to_go_narrow_10',
                component: GoBroadToGoNarrow10,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Go Broad To Go Narrow", pageNumber: "10 of 22"  }
            },
            {
                path: '/js_go_broad_to_go_narrow_11/:index',
                name: 'js_go_broad_to_go_narrow_11',
                component: GoBroadToGoNarrow11,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Go Broad To Go Narrow", pageNumber: "11 of 22"  }
            },
            {
                path: '/js_go_broad_to_go_narrow_12/:index',
                name: 'js_go_broad_to_go_narrow_12',
                component: GoBroadToGoNarrow12,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Go Broad To Go Narrow", pageNumber: "12 of 22"  }
            },
            {
                path: '/js_go_broad_to_go_narrow_13/:index',
                name: 'js_go_broad_to_go_narrow_13',
                component: GoBroadToGoNarrow13,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: true , title: "Go Broad To Go Narrow", pageNumber: "13 of 22"  },
                props: true,
            },
            {
                path: '/js_go_broad_to_go_narrow_13_other/:index',
                name: 'js_go_broad_to_go_narrow_13_other',
                component: GoBroadToGoNarrow13Other,
                meta: { authRequired: true, showNavigation: false, showNavigationInfo: false,  pageNumber: "13 of 22"},
                props: true,
            },
            {
                path: '/js_rapid_experiments_with_customers_14/:index',
                name: 'js_rapid_experiments_with_customers_14',
                component: RapidExperimentsWithCustomers14,
                meta: { authRequired: true,showNavigation: false, showNavigationInfo: false,  pageNumber: "14 of 22" },
                props: true,
            },
            {
                path: '/js_rapid_experiments_with_customers_15/:index',
                name: 'js_rapid_experiments_with_customers_15',
                component: RapidExperimentsWithCustomers15,
                meta: { authRequired: true, showNavigation: true,showNavigationInfo: true , title: "Rapid experiments with customers ", pageNumber: "15 of 22" }
            },
            {
                path: '/js_rapid_experiments_with_customers_16/:index',
                name: 'js_rapid_experiments_with_customers_16',
                component: RapidExperimentsWithCustomers16,
                meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "16 of 22" }
            },
            {
               path: '/js_rapid_experiments_with_customers_17/:index',
               name: 'js_rapid_experiments_with_customers_17',
               component: RapidExperimentsWithCustomers17,
               meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "17 of 22" }
            },
            {
                path: '/js_rapid_experiments_with_customers_18/:index',
                name: 'js_rapid_experiments_with_customers_18',
                component: RapidExperimentsWithCustomers18,
                meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "18 of 22" }
            },
            {
                path: '/js_rapid_experiments_with_customers_19/:index',
                name: 'js_rapid_experiments_with_customers_19',
                component: RapidExperimentsWithCustomers19,
                meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "19 of 22" }
            },
            {
                path: '/js_rapid_experiments_with_customers_20/:index',
                name: 'js_rapid_experiments_with_customers_20',
                component: RapidExperimentsWithCustomers20,
                meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "20 of 22" }
            },
            {
                path: '/js_rapid_experiments_with_customers_21/:index',
                name: 'js_rapid_experiments_with_customers_21',
                component: RapidExperimentsWithCustomers21,
                meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "21 of 22" }
            },
            {
                path: '/js_rapid_experiments_with_customers_22/:index',
                name: 'js_rapid_experiments_with_customers_22',
                component: RapidExperimentsWithCustomers22,
                meta: { authRequired: true,showNavigation: true, showNavigationInfo: true , title: "Rapid experiments with customers", pageNumber: "22 of 22" }
            },
            {
                path: '/finish_23/:index',
                name: 'finish_23',
                component: Finish23,
                meta: { authRequired: true,showNavigation: false, showNavigationInfo: false }
            }
            ,{
                path: '/js_go_broad_to_go_narrow_other_24/:index',
                name: 'js_go_broad_to_go_narrow_other_24',
                component: GoBroadToGoNarrow13Other,
                meta: { authRequired: true, showNavigation: false, showNavigationInfo: false  },
                props: true,
            },

            {
                path: '/time_to_reset_25/:index',
                name: 'time_to_reset_25',
                component: TimeToReset,
                meta: { authRequired: true,showNavigation: false, showNavigationInfo: false }
            }

        ]
    }
]

export default routes
